/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import * as Styles from '../../../../SharedModules/StyleConstant/StyleConstant';
import MaxLengthNumericEditor from '../../../../SharedModules/CustomAgGridEditor/inputComponent';

const ragRenderer = (params) => {
  const { value } = params;
  const { isTextColorRed } = params.colDef;
  const { printPrefixValue } = params.colDef;
  const { printPostfixValue } = params.colDef;
  if (value === '') return '';
  if (value < 0) {
    return (
      <span
        style={{
          color: isTextColorRed ? 'red' : '',
          fontWeight: params?.data?.isBottomRow ? 600 : 'normal',
        }}
      >
        {`(${printPrefixValue ? `${printPrefixValue} ` : ''}${value
          .toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })
          .substring(1)})` + `${printPostfixValue || ''}`}
      </span>
    );
  }
  if (value > -1) {
    return (
      <span style={{ fontWeight: params?.data?.isBottomRow ? 600 : 'normal' }}>
        {`${
          (printPrefixValue ? `${printPrefixValue} ` : '') +
          parseFloat(value)?.toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })
        }${printPostfixValue || ''}`}
      </span>
    );
  }
  return params.value || '';
};
function amountComparator(amount1, amount2) {
  let amt1 = null;
  let amt2 = null;
  if (amount1 && amount1?.toString()?.includes('$ ')) {
    amt1 = parseFloat(
      amount1?.toString().split('$ ')[1]?.toString()?.replace(',', '').trim()
    );
  } else {
    amt1 = parseFloat(amount1?.toString()?.replace(',', '').trim());
  }
  if (amount2 && amount2?.toString()?.includes('$ ')) {
    amt2 = parseFloat(
      amount2?.toString().split('$ ')[1]?.toString()?.replace(',', '').trim()
    );
  } else {
    amt2 = parseFloat(amount2?.toString()?.replace(',', '').trim());
  }
  if (amt1 === null && amt2 === null) {
    return 0;
  }
  if (amt1 === null) {
    return -1;
  }
  if (amt2 === null) {
    return 1;
  }

  return amt1 - amt2;
}

const comparator = (a, b) => {
  const aValue = parseFloat(
    a.replace('$ ', '').replace(/,/g, '').replace(/%/g, '')
  );
  const bValue = parseFloat(
    b.replace('$ ', '').replace(/,/g, '').replace(/%/g, '')
  );

  return aValue - bValue;
};

export const tableHead = [
  {
    headerName: 'Pharmacy Claims Section',
    field: 'field1',
    cellRenderer: 'TextBoxRender',
    cellClass: 'frr-ellipsis-text',
    editable: false,
    sortable: false,
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Brand Name',
    field: 'field2',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    isAmount: true,
    printPrefixValue: '$ ',
    cellRenderer: ragRenderer,
    comparator: amountComparator,
    minWidth: Styles.Width_167,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    alignment: 'right',
    isTextColorRed: true,
  },
  {
    headerName: 'Generic',
    field: 'field3',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    isAmount: true,
    comparator: amountComparator,
    printPrefixValue: '$ ',
    cellRenderer: ragRenderer,
    minWidth: Styles.Width_138,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    alignment: 'right',
    isTextColorRed: true,
  },
  {
    headerName: 'Multisource',
    field: 'field4',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    isAmount: true,
    comparator: amountComparator,
    printPrefixValue: '$ ',
    cellRenderer: ragRenderer,
    minWidth: Styles.Width_180,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    alignment: 'right',
    isTextColorRed: true,
  },
  {
    headerName: 'Total',
    field: 'field5',
    printPrefixValue: '$ ',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    comparator: amountComparator,
    isAmount: true,
    cellRenderer: ragRenderer,
    minWidth: Styles.Width_180,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    alignment: 'right',
    isTextColorRed: true,
  },
];
export const jtableHead = [
  {
    headerName: 'JCode Claims Section',
    field: 'field1',
    cellRenderer: 'TextBoxRender',
    cellClass: 'frr-ellipsis-text',
    editable: false,
    sortable: false,
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Brand Name',
    field: 'field2',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    isAmount: true,
    printPrefixValue: '$ ',
    cellRenderer: ragRenderer,
    comparator: amountComparator,
    minWidth: Styles.Width_167,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    alignment: 'right',
    isTextColorRed: true,
  },
  {
    headerName: 'Generic',
    field: 'field3',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    isAmount: true,
    comparator: amountComparator,
    printPrefixValue: '$ ',
    cellRenderer: ragRenderer,
    minWidth: Styles.Width_138,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    alignment: 'right',
    isTextColorRed: true,
  },
  {
    headerName: 'Multisource',
    field: 'field4',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    isAmount: true,
    comparator: amountComparator,
    printPrefixValue: '$ ',
    cellRenderer: ragRenderer,
    minWidth: Styles.Width_180,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    alignment: 'right',
    isTextColorRed: true,
  },
  {
    headerName: 'Total',
    field: 'field5',
    printPrefixValue: '$ ',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    comparator: amountComparator,
    isAmount: true,
    cellRenderer: ragRenderer,
    minWidth: Styles.Width_180,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    alignment: 'right',
    isTextColorRed: true,
  },
];
export const totaltableHead = [
  {
    headerName: 'Grand Total Section',
    field: 'field1',
    cellRenderer: 'TextBoxRender',
    cellClass: 'frr-ellipsis-text',
    editable: false,
    sortable: false,
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Brand Name',
    field: 'field2',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    isAmount: true,
    printPrefixValue: '$ ',
    cellRenderer: ragRenderer,
    comparator: amountComparator,
    minWidth: Styles.Width_167,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    alignment: 'right',
    isTextColorRed: true,
  },
  {
    headerName: 'Generic',
    field: 'field3',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    isAmount: true,
    comparator: amountComparator,
    printPrefixValue: '$ ',
    cellRenderer: ragRenderer,
    minWidth: Styles.Width_138,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    alignment: 'right',
    isTextColorRed: true,
  },
  {
    headerName: 'Multisource',
    field: 'field4',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    isAmount: true,
    comparator: amountComparator,
    printPrefixValue: '$ ',
    cellRenderer: ragRenderer,
    minWidth: Styles.Width_180,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    alignment: 'right',
    isTextColorRed: true,
  },
  {
    headerName: 'Total',
    field: 'field5',
    printPrefixValue: '$ ',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    comparator: amountComparator,
    isAmount: true,
    cellRenderer: ragRenderer,
    minWidth: Styles.Width_180,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    alignment: 'right',
    isTextColorRed: true,
  },
];
